import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import LoginForm from '../components/LoginForm';
import ServerSelector from '../components/ServerSelector'; // Dosya yolunu projene göre kontrol et

const Login = () => {
  return (
    // Tüm sayfanın arka planını koyu yapıp, tam ekran yüksekliği (100vh) veriyoruz
    <div style={{ position: 'relative', backgroundColor: '#121212', minHeight: '100vh' }}>
      
      {/* SUNUCU SEÇİCİ - Sayfanın sağ üst köşesine sabitlendi */}
      <div style={{ position: 'absolute', top: 20, right: 20, zIndex: 10 }}>
        <ServerSelector />
      </div>

      {/* İçeriği dikey ve yatay olarak tam ortaya hizalayan kapsayıcı */}
      <Container className="d-flex flex-column justify-content-center align-items-center min-vh-100">
        
        {/* BAŞLIK / LOGO */}
        <h1 className='fw-bold mb-4' style={{ color: "white", letterSpacing: '2px' }}>
          turnaments
        </h1>

        {/* GİRİŞ FORMU */}
        {/* Formun çok genişlemesini engellemek için maxWidth verdik */}
        <div className="w-100" style={{ maxWidth: '450px' }}>
          <LoginForm />
        </div>

      </Container>
    </div>
  );
}

export default Login;